<mat-accordion multi class="expand-collapse-panel">
    <mat-expansion-panel>
        <mat-expansion-panel-header>
        </mat-expansion-panel-header>
        <form autocomplete="off" [formGroup]="form" id="filter" class="filter-form">
            <div class="filter-field">
                <mat-form-field class="search-input">
                    <mat-label>Customer Id</mat-label>
                    <input matInput placeholder="Customer Id" id="CustomerId" type="text" formControlName="CustomerId" />
                </mat-form-field>
            </div>
            <div class="filter-field">
                <mat-form-field class="search-input">
                    <mat-label> Customer Name </mat-label>
                    <input matInput placeholder="Customer Name" id="CustomerName" type="text" formControlName="CustomerName" />
                </mat-form-field>
            </div>
            <div class="filter-actions">
                <button type="button" class="btn mat-flat-button btn-primary" (click)="onFilter()">
                    {{ changeTypeButton() ? 'Reset' : 'Filter' }}
                </button>
            </div>
        </form>
    </mat-expansion-panel>
</mat-accordion>